// WO-105：浏览器缓存重新选取公开字段，不保存正文、附件、回执或内部编号。
import type { PublicScreen } from "../../lib/public-api";

function record(value: unknown): Record<string, unknown> | null {
  return value !== null && typeof value === "object" && !Array.isArray(value) ? value as Record<string, unknown> : null;
}
function text(value: unknown): value is string { return typeof value === "string" && value.trim().length > 0; }
function date(value: unknown): value is string { return text(value) && Number.isFinite(Date.parse(value)); }

export function publicScreenPayload(value: unknown): PublicScreen | null {
  const root = record(value), profile = record(root?.profile), snapshot = record(profile?.snapshot);
  if (!root || !profile || !snapshot || !text(root.etag) || !date(root.generatedAt) || !text(profile.name) || typeof profile.syntheticNotice !== "string" || !date(snapshot.validAt) || !Array.isArray(snapshot.metrics) || !Array.isArray(root.items)) return null;
  const items: PublicScreen["items"][number][] = [];
  const ids = new Set<string>();
  for (const value of root.items.slice(0, 20)) {
    const item = record(value);
    if (!item || !text(item.id) || !text(item.title) || typeof item.digest !== "string" || !date(item.date) || !text(item.channelKey) || !text(item.channelTitle) || ids.has(item.id)) return null;
    ids.add(item.id);
    items.push({ id: item.id, title: item.title, digest: item.digest, date: item.date, channelKey: item.channelKey as PublicScreen["items"][number]["channelKey"], channelTitle: item.channelTitle });
  }
  const metrics: PublicScreen["profile"]["snapshot"]["metrics"][number][] = [];
  for (const value of snapshot.metrics) {
    const metric = record(value);
    // 缺值、缺口径或缺追溯时点均不显示，绝不填零或伪造计算时点。
    if (!metric || !text(metric.label) || typeof metric.value !== "number" || !Number.isFinite(metric.value) || !text(metric.caliber) || !date(metric.validAt) || !date(metric.computedAt) || typeof metric.definitionVersion !== "number" || !Number.isSafeInteger(metric.definitionVersion) || metric.definitionVersion < 1) continue;
    metrics.push({ label: metric.label, value: metric.value, caliber: metric.caliber, validAt: metric.validAt, computedAt: metric.computedAt, definitionVersion: metric.definitionVersion });
  }
  return { profile: { name: profile.name, syntheticNotice: profile.syntheticNotice, snapshot: { validAt: snapshot.validAt, metrics } }, items, generatedAt: root.generatedAt, etag: root.etag };
}
